import { render, staticRenderFns } from "./DislikeCard.vue?vue&type=template&id=0c85a993&"
import script from "./DislikeCard.vue?vue&type=script&lang=js&"
export * from "./DislikeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports